"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAck = exports.IpcChannel = void 0;
var IpcChannel;
(function (IpcChannel) {
  IpcChannel["GET_VERSION"] = "GET_VERSION";
  IpcChannel["SET_USER_ID"] = "SET_USER_ID";
  IpcChannel["SET_COOKIE"] = "SET_COOKIE";
  IpcChannel["CLEAR_COOKIES"] = "CLEAR_COOKIES";
  IpcChannel["SEND_CONVERSATION_NOTIFICATION"] = "SEND_CONVERSATION_NOTIFICATION";
  IpcChannel["SEND_ABM_NOTIFICATION"] = "SEND_ABM_NOTIFICATION";
  IpcChannel["SEND_EXTERNAL_NOTIFICATION"] = "SEND_EXTERNAL_NOTIFICATION";
  IpcChannel["OPEN_CONVERSATION"] = "OPEN_CONVERSATION";
  IpcChannel["OPEN_VISITOR"] = "OPEN_VISITOR";
  IpcChannel["SEND_CONVERSATION_MESSAGE"] = "SEND_CONVERSATION_MESSAGE";
  IpcChannel["OPEN_EXTERNAL_LINK"] = "OPEN_EXTERNAL_LINK";
  IpcChannel["EXTERNAL_OPEN_URL"] = "EXTERNAL_OPEN_URL";
  IpcChannel["SHOW_BADGE_ICON_NUMBER"] = "SHOW_BADGE_ICON_NUMBER";
  IpcChannel["GET_WINDOW_VISIBLE"] = "GET_WINDOW_VISIBLE";
  IpcChannel["ON_FOCUS"] = "ON_FOCUS";
  IpcChannel["LOG"] = "LOG";
  IpcChannel["REQUEST_ACCESS"] = "REQUEST_ACCESS";
})(IpcChannel = exports.IpcChannel || (exports.IpcChannel = {}));
var getAck = function getAck(type) {
  return type + '_ACK';
};
exports.getAck = getAck;